<template>
	<v-container>
		<div id="geomap"></div>
		<v-overlay v-if="fetchLoading" :value="fetchLoading">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
		</v-overlay>
		<template v-else>
			<template v-if="!finaltext">
				<v-row>
					<v-col v-if="isMobile">
						<template v-if="failurePosition">
							<permissions-texts class="pt-4 mb-3" />
						</template>

						<search-map
							v-if="(handler == 0 || handler == 2) && lodging"
							:person="person"
							:save="save"
							:token="token"
							:geofence="lodging.place.geofence"
							:placeName="lodging.place.name"
						/>
						<v-overlay v-if="loading" :value="loading">
							<v-progress-circular
								indeterminate
								color="primary"
							></v-progress-circular>
							<div class="pt-2">Guardando tu ubicación, por favor espere.</div>
						</v-overlay>
					</v-col>
					<v-col v-else>
						<v-alert type="info" v-if="handler == 0">
							Tambien puedes ingresar tu ubicación desde tu celular
						</v-alert>
						<v-alert v-if="handler == 1" type="info">
							Para registrar tu ubicación debes ingresar desde tu celular
						</v-alert>
						<search-map
							v-if="(handler == 0 || handler == 2) && lodging"
							:person="person"
							:save="save"
							:token="token"
							:geofence="lodging.place.geofence"
							:placeName="lodging.place.name"
						/>
					</v-col>
				</v-row>
			</template>
			<template v-else>
				<v-row justify="center" align="center" style="height:85vh">
					<v-col cols="12">
						<guest-person-register
							:personId="idPerson"
							:person="person"
							:token="token"
							:finaltext="finaltext"
						/>
					</v-col>
				</v-row>
			</template>
		</template>
	</v-container>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';
import { api as baseURL } from '@/config/index.js';

export default {
	components: {
		GuestPersonRegister: () => import('@/components/auth/GuestPersonRegister'),
		PermissionsTexts: () => import('@/components/user/PermissionsTexts'),
		SearchMap: () => import('@/components/user/SearchMap'),
	},
	data() {
		return {
			fetchLoading: false,
			failurePosition: null,
			dialog: false,
			token: '',
			idPerson: '',
			loading: false,
			person: null,
			finaltext: '',
			handler: null,
			idNotification: '',
			idLodging: '',
			lodging: null,
		};
	},
	computed: {
		hasIdCompany() {
			return this.person && this.person.idCompany;
		},
	},
	created() {
		this.dialog = true;
		let data = this.$route.params.token;
		let buff = new Buffer(data, 'base64');
		this.token = buff.toString('ascii');
		this.idPerson = this.$route.params.id;
		this.idLodging = this.$route.params.lodging;
		this.idNotification = this.$route.params.idNotification;
		this.handler = this.$route.params.handler;
	},
	async mounted() {
		this.fetchLoading = true;
		await this.getPerson();
		await this.getLodging();
		if (this.handler == 0 || this.handler == 1) {
			this.setGeo();
		}
		this.fetchLoading = false;
	},
	methods: {
		async getPerson() {
			try {
				const { data } = await axios.get(`${baseURL}/person/${this.idPerson}`, {
					headers: {
						Authorization: `Bearer ${this.token}`,
					},
				});
				this.person = data.person;
			} catch (error) {
				this.snackbar({
					content: this.errorMessage(error),
					color: 'error',
				});
			}
		},
		async getLodging() {
			const { data } = await axios.get(`${baseURL}/timeline/person/${this.idPerson}`, {
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			});

			this.lodging = data.lodgings.find(lod => lod._id === this.idLodging);
		},
		setGeo() {
			this.dialog = false;
			if (this.isMobile) {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						this.setPosition,
						this.setFailurePosition
					);
				} else {
					this.snackbar({
						content: 'Ocurrió un problema al obtener la localización',
						color: 'error',
					});
				}
			}
		},
		async setPosition(position) {
			try {
				this.loading = !this.loading;
				const payload = {
					_id: this.person._id,
					geolocation: {
						coordinates: [position.coords.latitude, position.coords.longitude],
						date: new Date(),
					},
				};
				let isInside = false;
				if (this.lodging.place.geofence) isInside = this.setInside(position.coords);
				await this.save(payload, isInside);
				this.setFinalText();
			} catch (error) {
				this.snackbar({
					content: this.errorMessage(error),
					color: 'error',
				});
			} finally {
				this.loading = !this.loading;
			}
		},
		setFailurePosition(err) {
			this.failurePosition = err;
		},
		formatToken(find, replace, str) {
			while (str.indexOf(find) > -1) {
				str = str.replace(find, replace);
			}
			return str;
		},
		async save(payload, newState) {
			try {
				payload.geolocation.idNotification = this.idNotification;
				payload.geolocation.idLodging = this.idLodging;
				const { data } = await axios(`${baseURL}/person/${payload._id}/geolocation`, {
					data: payload.geolocation,
					method: 'put',
					headers: {
						Authorization: `Bearer ${this.token}`,
					},
				});
				await this.updateNotification(newState);
				this.setFinalText();
				this.person = data.person;
			} catch (error) {
				this.snackbar({
					content: this.errorMessage(error),
					color: 'error',
				});
			}
		},
		async updateNotification(newState) {
			newState = newState == 0 ? 2 : 1;
			await axios(
				`${baseURL}/lodging/${this.idLodging}/notification/${this.idNotification}`,
				{
					method: 'put',
					data: { state: newState },
					headers: {
						Authorization: `Bearer ${this.token}`,
					},
				}
			);
		},
		setFinalText() {
			this.finaltext = 'Ubicación actualizada';
		},
		errorMessage(e) {
			const status = e.response.status === 401;
			if (status) this.finaltext = 'Ha expirado su enlace';
			return status ? 'Ha expirado este enlace' : e.message;
		},
		setInside(position) {
			// eslint-disable-next-line no-undef
			let map = new google.maps.Map(document.getElementById('geomap'));
			// eslint-disable-next-line no-undef
			let marker = new google.maps.Marker({
				map: map,
				position: {
					lat: position.latitude,
					lng: position.longitude,
				},
			});
			// eslint-disable-next-line no-undef
			let polygons = new google.maps.Polygon({
				paths: this.lodging.place.geofence,
			});
			marker.setMap(map);
			polygons.setMap(map);
			// eslint-disable-next-line no-undef
			return google.maps.geometry.poly.containsLocation(marker.position, polygons);
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>
